<template>
  <div class="row" v-if="car">
    <div class="col-12 col-lg-6 pt-1 pt-md-4">
      <h4 class="mb-1">{{fullName}}</h4>
      <h2 class="mb-4">{{template.customer_name}}</h2>
    </div>
    <div class="col-12 col-lg-6 pt-3 image">
      <img
        :src="image"
        :alt="template.customer_name"
        @load="imageLoaded"
        v-show="imgLoaded"
        class="car-image"
      >
      <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw text-red" v-show="!imgLoaded"></i>
      <span
        class="support-text"
        v-show="imgLoaded"
      >*Yllä oleva kuva ei välttämättä vastaa tilaamaanne autoa.</span>
    </div>
  </div>
</template>

<script>
/**
 * Car heading component
 */
import { mapGetters, mapActions } from "vuex";
export default {
  /**
   * @description
   * @returns {Object}
   */
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      getCarByKey: "getCarByKey",
      image: "carImage",
      imgLoaded: "imgLoaded",
      firstName: "getFirstName",
      lastName: "getLastName",
      getTemplateById: "getTemplateById"
    }),
    /**
     * @description Get car by key
     * @returns {Object}
     */
    car() {
      return this.getCarByKey(this.$route.params.car);
    },
    template() {
      return this.getTemplateById(this.car.template_id);
    },
    /**
     * @description Full name of current customer
     * @returns {String}
     */
    fullName() {
      return this.firstName + " " + this.lastName;
    }
  },
  methods: {
    ...mapActions({
      getImageUrl: "getImageUrl",
      setImageLoaded: "setImageLoaded"
    }),
    /**
     * @description Set image loaded
     */
    imageLoaded() {
      this.setImageLoaded();
    }
  },
  /**
   * @description
   */
  mounted() {
    if (!this.imgLoaded) {
      this.getImageUrl(this.$route.params.car);
    }
  }
};
</script>

<style lang="scss">
</style>
